module.exports = __webpack_public_path__ + "static/img/son10_active.acc40284.jpg";